import { useTranslation } from 'react-i18next';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { EmptyState } from '@/components/common/EmptyState';

/** Landing page of a freshly opened second work order window (#3653). */
export default function WorkOrderWindowPage() {
  const { t } = useTranslation('workorders');
  return (
    <EmptyState
      icon={<OpenInNewIcon />}
      title={t('secondWindow.readyTitle')}
      description={t('secondWindow.readyDescription')}
    />
  );
}
